module.exports = __webpack_public_path__ + "img/CRMP-logo.bbbb7033.jpg";